import React, {Component} from 'react';
import {Form, Input, Label, Table, Button, InputGroup, FormGroup} from 'reactstrap';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Hour from 'customers/Hour';
import Dialog from 'apa/containers/Dialog';
import * as customers from 'customers/actions/customers'
import * as hours from 'customers/actions/hours'

@connect(
    state => {
        return {
            customers: state.customers
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id) => {
                dispatch(customers.fetchCustomer(customer_id))
            },
            add: (hour) => dispatch(hours.add(hour))
        }
    }
)
export default class HourList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            customer: null,
            newHour: {
                hours: '',
            },
            isNewHourModalOpen: false
        };
    }

    componentDidMount() {
        this.fetchCustomer()
    }

    @autobind
    fetchCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id)
    }

    render() {
        const id = this.props.match.params.id;
        const customer = this.props.customers.customer;
        if (!customer)
            return <h1>Loading</h1>;
        const hours = customer.hours;
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <InputGroup>
                    <Button color='primary' onClick={this.toggleNewHourModal}>
                        Stunden erfassen
                    </Button>
                    <Dialog
                        toggle={this.toggleNewHourModal}
                        confirm={this.confirmNewHour}
                        isOpen={this.state.isNewHourModalOpen}
                        title={'Stunden erfassen'}
                    >
                        <Form>
                            <FormGroup>
                                <Label>
                                    Stunden
                                </Label>
                                <Input type='number' name='hours' value={this.state.newHour.hours}
                                       onChange={this.handleInput}/>
                            </FormGroup>
                        </Form>
                    </Dialog>
                </InputGroup>

                <Table bordered>
                    <thead>
                    <tr>
                        <th>
                            Datum
                        </th>
                        <th>
                            Stunden
                        </th>
                        <th>

                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        hours.map(
                            (hour) => <Hour key={`hour_${hour.id}`} hour={hour}/>
                        )
                    }
                    </tbody>
                </Table>

            </DetailContainer>
        )
    }

    @autobind
    handleInput(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState(
            {
                ...this.state,
                newHour: {
                    ...this.state.newHour,
                    [name]: value
                }
            }
        )
    }

    @autobind
    confirmNewHour() {
        this.props.add(
            {
                ...this.state.newHour,
                customer: this.props.customers.customer.id
            }
        );
        this.toggleNewHourModal();
    }

    @autobind
    toggleNewHourModal() {
        this.setState(
            {
                ...this.state,
                isNewHourModalOpen: !this.state.isNewHourModalOpen
            }
        )
    }
}

